<section *ngIf="deadlines && nthdeadlines">
<div class="container" style="margin-top: 60px;text-align: center">
  <h2 *ngIf="nthdeadlines" style="text-transform: uppercase;color: var(--btn-bgColor);">Règlement {{nthdeadlines}}ème échéances</h2>
  <h4 *ngIf="order" style="color: var(--header-bgColor);">Commande {{order.id}}</h4>
</div>

<div class="details-cmd" style="margin-top: 70px">
<div class="container">
<header class="flexible">
    <h5 class="inline-block text-uppercase">01. Récapitulatif</h5>
    <a  title="Montrer/Cacher les détails" class="inline-block text-uppercase">
      <i class="fa fa-edit"></i>
    </a>
</header>
<div class="table-wrapper">
  <div class="width-100 table">
    <div  class="table-row flexible width-100">
      <div  class="flexible width-100" style="border-top: 1px solid #E0E0E0">
        <div class="column flexible text-left col-md-10" *ngIf="nthdeadlines"><span style="padding-right: 10px;word-break: break-all;">{{nthdeadlines}}ème échéance</span><span></span> <span class="opacity-50"></span></div>
        <div class="column flexible has-price col-md-2" *ngIf="deadlines"><span class="price ">{{deadlines[nthdeadlines-1].amount.toFixed(2)}} €</span></div>
      </div>
    </div>

    <div class="table-row flexible width-100 toto">
      <div class="flexible width-100">
        <div class="column flexible title space-between text-uppercase width-100">
          <div class="price" style="text-transform: uppercase;font-weight: bold">Total final</div>
          <div class="price  text-green" style="margin-left: auto">{{deadlines[nthdeadlines-1].amount.toFixed(2)}} €</div>
        </div>
      </div>
    </div>

  </div>
</div>
</div>
<div *ngIf="deadlines[nthdeadlines]" class="container" style="margin-bottom: 50px">
  <h4 style="text-transform: uppercase;margin-bottom: 5px;">Prochaines échéances</h4>
  <div style="font-size: 18px">- Le {{deadlines[nthdeadlines].date|date:'dd/MM/yyyy'}} : <span style=";color: var(--btn-bgColor)">{{deadlines[nthdeadlines].amount.toFixed(2)}}e</span></div>
</div>
</div>

<div class="details-cmd" id="credit-card">
  <div class="container" style="margin-bottom: 35px;text-align: center">
    <a (click)="valider()" title="Valider mon paiement" class="btn inline-block btn-green width-100-475">Payer</a>
  </div>
</div>
</section>
